import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup } from "@angular/forms";

import { MainConfig, FormToolsService } from "@atenea-cms";
import { Country, CountryService } from "../../countries/shared";
import { ResellerService, ResellerFormService } from "../shared";

@Component({
  selector: "reseller-detail",
  templateUrl: "./reseller-detail.component.html",
  styleUrls: ["./reseller-detail.component.scss"],
})
export class ResellerDetailComponent implements OnInit {
  loading: boolean = false;
  form: FormGroup;
  types: Array<Object> = [];
  countries: Array<Country> = [];

  constructor(
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    public ft: FormToolsService,
    public mainConfig: MainConfig,
    private countryService: CountryService,
    private resellerService: ResellerService,
    private formService: ResellerFormService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Distribuidores - " + this.mainConfig.cmsName);
    this.loading = true;

    this.route.params.subscribe((params) => {
      this.types = [
        { value: 1, name: "Distribuidor" },
        { value: 2, name: "Tienda" },
      ];

      this.countryService.getAll().subscribe((countries) => {
        this.countries = countries;

        if (params["id"]) {
          this.resellerService.getById(params["id"]).subscribe((item) => {
            this.form = this.formService.getForm(item);
            this.loading = false;
          });
        } else {
          this.form = this.formService.getForm();
          this.loading = false;
        }
      });
    });
  }

  refresh(id) {
    this.router.navigate(["/resellers/" + id]);
  }

  goToBack() {
    this.router.navigate(["/resellers"]);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/resellers/reseller-detail/reseller-detail.component.ts